import React from 'react'
import './Table.css'


const Table = ({
    columns = [],
    data = []
}) => {

    const rowIds = columns.map(item => item.id);
    const rowClasses = columns.map(item => item.class);

    return (
        <>
            <div className="table">
                <div className="table-header">
                    {
                        columns.map((col) => {
                            return <div className={'column ' + col['class']}>
                                {
                                    col['label']
                                }
                            </div>
                        })
                    }
                </div>
                <div className="table-rows">
                    {
                        data.map((item) => {
                            return rowIds.map((row,index) => {
                                return <div className={'column ' + rowClasses[index]}>{item[row]}</div>
                            })
                        })
                    }
                </div>
            </div>
        </>
    )


}

export default Table;